import { render, staticRenderFns } from "./SGPFiltroAvancadoComponent.vue?vue&type=template&id=237492a6"
import script from "./SGPFiltroAvancadoComponent.vue?vue&type=script&lang=js"
export * from "./SGPFiltroAvancadoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports